const initialState = {
  account: {
    callInfo: false,
    connected: false,
    email: '',
    isLoading: true,
    revoked: false,
    version: '',
  },
  oauthPath: '',
}

// Set the account as disconnected only so the connected account page
// will re-render and redirect to the disconnected account page where
// the account data will be fetched
const setAccountDeleted = (state) => ({
  ...state,
  account: {
    ...state.account,
    connected: false,
  },
})

const setAccountLoaded = (state, {
  call_info: callInfo,
  connected,
  email,
  granted,
  oauth_path: oauthPath,
  version,
}) => ({
  ...state,
  account: {
    ...state.account,
    callInfo,
    connected,
    granted,
    email,
    version,
  },
  oauthPath,
})

const setAccountLoading = (state, isLoading) => ({
  ...state,
  account: {
    ...state.account,
    isLoading,
  },
})

const setCallInfo = (state, callInfo) => ({
  ...state,
  account: {
    ...state.account,
    callInfo,
  },
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GOTOMEETING_DELETE_ACCOUNT_SUCCESS':
      return setAccountDeleted(state)
    case 'GOTOMEETING_UPDATE_CALL_INFO':
      return setCallInfo(state, payload)
    case 'GOTOMEETING_FETCH_ACCOUNT':
      return setAccountLoading(state, true)
    case 'GOTOMEETING_FETCH_ACCOUNT_SUCCESS':
      return setAccountLoaded(state, payload)
    case 'GOTOMEETING_FETCH_ACCOUNT_COMPLETE':
      return setAccountLoading(state, false)
    default:
      return state
  }
}
